import React, { RefObject } from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import classNames from 'classnames';

import { createUseThemedStyles } from '@/hooks';
import { Loader } from '@/components';

const useStyles = createUseThemedStyles({
	loader: {
		top: '50%',
		left: '50%',
		position: 'absolute',
		transform: 'translate(-50%, -50%)',
	},
	children: ({ isLoading }: { isLoading?: boolean }) => ({
		opacity: isLoading ? 0 : 1,
	}),
});

interface LoadingButtonProps extends ButtonProps {
	isLoading?: boolean;
	classNameInner?: string;
}

export const LoadingButton = React.forwardRef(function(
	{ isLoading, classNameInner, className, onClick, children, ...props }: LoadingButtonProps,
	ref: ((instance: HTMLButtonElement | null) => void) | RefObject<HTMLButtonElement> | null | undefined
) {
	const classes = useStyles({ isLoading });

	return (
		<Button
			ref={ref}
			className={classNames('position-relative', className)}
			onClick={(event) => {
				if (isLoading) {
					event.preventDefault();
					return;
				}

				if (onClick) {
					onClick(event);
				}
			}}
			{...props}
		>
			{isLoading && <Loader size={24} className={classes.loader} />}
			<span className={classNames(classes.children, classNameInner)}>{children}</span>
		</Button>
	);
});
